const prefix = 'latest-payments__';

export default {
  filterButton: `${prefix}filter-button`,
  dateRangePicker: `${prefix}date-range-picker`,
  searchField: `${prefix}search-field`,
  pagerBackButton: `${prefix}pager-back-button`,
  pagerForwardButton: `${prefix}pager-forward-button`
};
